import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRedux } from "../../hooks/index";
import LogoutLayoutWrapper from "../../components/LogoutLayoutWrapper";
import withRouter from "../../components/withRouter";
import { logoutUser } from "../../redux/actions";

const Logout = (props: any) => {
  const { t } = useTranslation();
  const { dispatch } = useRedux();
  const navigate = useNavigate();

  useEffect(() => {
    // IMPORTANTE: NÃO usar localStorage.clear() pois limpa o cache de conversas
    // Limpar apenas dados de autenticação, mantendo cache para melhor UX

    // Dados de autenticação
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");
    localStorage.removeItem("oauth_state");
    localStorage.removeItem("oauth_connector_id");

    // Dados de sessão (mas NÃO o cache de conversas)
    localStorage.removeItem("debugMode");
    localStorage.removeItem("pwa-installed");
    localStorage.removeItem("pwa-install-time");

    // Marcar que o cache pode ser do usuário anterior (será verificado no login)
    const cachedUserId = localStorage.getItem("chatCacheUserId");
    if (cachedUserId) {
      localStorage.setItem("chatCachePreviousUser", cachedUserId);
    }

    // Clear cookies
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    // Dispatch logout in background
    dispatch(logoutUser());

    // Immediate redirect (no delay)
    window.location.replace("/auth-login");
  }, [dispatch]);

  return (
    <LogoutLayoutWrapper>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          maxWidth: "400px",
          textAlign: "center",
        }}
      >
        {/* Loading spinner */}
        <CircularProgress
          size={48}
          sx={{
            color: "#54398E",
            mb: 2,
          }}
        />

        {/* Mensagem de logout */}
        <Typography
          variant="h5"
          sx={{
            fontSize: { xs: "1.25rem", md: "1.5rem" },
            color: "#2d3748",
            fontWeight: "600",
            textAlign: "center",
            lineHeight: 1.3,
          }}
        >
          Encerrando sessão...
        </Typography>

        {/* Descrição */}
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "0.95rem", md: "1rem" },
            color: "#718096",
            textAlign: "center",
            maxWidth: "320px",
            lineHeight: 1.5,
          }}
        >
          Redirecionando para login
        </Typography>
      </Box>
    </LogoutLayoutWrapper>
  );
};

export default withRouter(Logout);
